/**
 * @external {vinyl~File} https://github.com/gulpjs/vinyl#new-vinyloptions
 */
